import { render, staticRenderFns } from "./PaginaSpettacoli.vue?vue&type=template&id=b88bf01e"
import script from "./PaginaSpettacoli.vue?vue&type=script&lang=js"
export * from "./PaginaSpettacoli.vue?vue&type=script&lang=js"
import style0 from "./PaginaSpettacoli.vue?vue&type=style&index=0&id=b88bf01e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports